export default __webpack_public_path__ + "static/media/legend-map.946cb9bd.png";